(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paperideas-brand"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('pi-brand'); if(!root) return;
  var data={
    ruled:{k:'RULED · 横罫',t:'横罫（罫幅8mm）',d:'文章や日記、勉強のノートに。一定の行間で、まっすぐ美しく書けます。',l:['文章・日記・議事録に最適','行間そろえで、見返しやすい','いちばん定番の使いやすさ']},
    grid:{k:'GRID · 方眼',t:'方眼（マス目5mm）',d:'図やレイアウト、勉強に。タテヨコを揃えて、自由に書き込めます。',l:['図解・レイアウト・数式に','文字も表もきれいに整う','バレットジャーナルにも人気']},
    dot:{k:'DOT · ドット',t:'ドット（間隔5mm）',d:'主張しすぎないガイド。自由さと整えやすさを両立します。',l:['線が目立たず、仕上がりすっきり','手帳デコ・ジャーナリングに','図も文章も、思いのまま']},
    blank:{k:'PLAIN · 無地（自社サイト初登場）',t:'無地',d:'ページ番号のほかは、なにもない一枚。スケッチやアイデア出しに。自社サイトにて新登場です。',l:['スケッチ・マインドマップに','レイアウトを選ばない自由さ','ページ番号付きで、白紙でも整理しやすい']}
  };
  var paper=document.getElementById('rulPaper');
  var K=document.getElementById('rulK'),T=document.getElementById('rulTitle'),D=document.getElementById('rulDesc'),L=document.getElementById('rulList');
  root.querySelectorAll('.rul-tabs button').forEach(function(b){
    b.addEventListener('click',function(){
      root.querySelectorAll('.rul-tabs button').forEach(function(x){x.classList.remove('active');});
      b.classList.add('active');
      var r=b.getAttribute('data-r'), o=data[r];
      paper.setAttribute('data-r',r);
      K.textContent=o.k; T.textContent=o.t; D.textContent=o.d;
      L.innerHTML=o.l.map(function(i){return '<li><b></b><span>'+i+'</span></li>';}).join('');
    });
  });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    root.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  } else { root.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');}); }
  root.querySelectorAll('a[href^="#pi-"]').forEach(function(a){
    a.addEventListener('click',function(e){var t=document.querySelector(a.getAttribute('href')); if(t){e.preventDefault(); t.scrollIntoView({behavior:'smooth'});}});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
